import { Locale } from 'types';

export const creditCheckTranslations = {
  [Locale.en]: {
    creditCheckApplication: 'Credit Check Application',
    softCreditInquiry: 'Soft credit inquiry with no impact to homeowner credit score',
    applicantInformation: 'Applicant Information',
    applicantDescription: 'At least one applicant must be on property title',
    consumerSolarApplicantDescription: 'Enter name as it appears on submitted government ID',
    firstName: 'First Name',
    middleName: 'Middle Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    dateOfBirth: 'Date of Birth',
    dobRequired: 'Date of birth is required',
    socialSecurityNumber: 'Social Security Number',
    ssnDescription: 'Last 4 digits required, but full SSN recommended for best results',
    ssnErrorMessage: 'Last 4 digits required',
    ssnFullErrorMessage: '9 digits is required',
    nineDigitSsnHelpText: 'Full 9-digit SSN required',
    nineDigitSsnErrorMessage: 'A full 9-digit SSN is required',
    fullSsnDescription: 'Full SSN is required for verification to get the best results',
    ssnExample: 'e.g. 555555555 or 5555',
    fullSsnExample: 'e.g. 555555555',
    additionalApplicant: 'Additional Applicant',
    additionalApplicantDescription:
      'Must be an immediate family member (spouse/domestic partner, parent, child, or sibling)',
    differentEmailRequired: 'Must use a different email address than the primary applicant',
    eitherApplicantQualified:
      'Either applicant can be credit qualified, and at least one applicant must appear on property title report',
    addressInformation: 'Mailing Address Information',
    propertyAddress: 'Property Address Information',
    address: 'Address',
    address1: 'Address 1',
    address2: 'Address 2',
    city: 'City',
    state: 'State',
    zipCode: 'Zip Code',
    latitude: 'Latitude',
    longitude: 'Longitude',
    disclosures: 'Disclosures',
    disclosuresAlreadyAccepted: 'Disclosures already accepted. No further action required.',
    cancel: 'Cancel',
    submit: 'Submit',
    firstNameRequired: 'First Name is a required field.',
    lastNameRequired: 'Last Name is a required field.',
    phoneNumberRequired: 'Phone Number is a required field.',
    phoneNumberLength: 'Phone number must be 10 digits.',
    emailRequired: 'Email is a required field.',
    invalidEmail: 'Invalid email address.',
    ssnRequired: 'Minimum of last 4 of SSN is required',
    fullSsnRequired: 'Full SSN is required',
    ssnFormat: 'SSN value must match format 555555555 or 5555',
    fullSsnFormat: 'SSN value must match format 555555555',
    addressRequired: 'Address is a required field.',
    cityRequired: 'City is a required field.',
    stateRequired: 'State is a required field.',
    zipRequired: 'Zip is a required field.',
    creditApplicationDisclosureRequired: 'You must agree to the credit application disclosure.',
    applicationSubmittedSuccess: 'Application submitted successfully',
    errorSubmittingApplication: 'Error submitting application',
    creditUnderwritingComplete: 'Credit Underwriting Is Complete',
    creditUnderwritingCompleteMessage:
      'Credit underwriting for this Account has already been approved. Additional applications are not allowed',
    creditUnderwritingCompleteWithCapMessage:
      'Credit underwriting for this Account has already been approved and has reached the maximum monthly payment cap. Additional applications are not allowed',
    invalidSsnZeros: 'Invalid SSN format. SSN cannot be 0000.',
    invalidSsnPattern: 'Invalid SSN format. SSN cannot start with 666, have 00 as middle digits, or end with 0000.',
    usePropAddressForMainApplicantAddress: 'Use property address as the primary applicant address',
    lightReachDisclosuresTitle: 'LightReach Disclosures',
    language: 'Preferred Language',
    languageDescription:
      'Select your preferred language. Changing preferred language will set the customer’s preferred language.',
    languageChangeAlertTitle: 'Language Change Notice',
    languageChangeAlertMessage:
      'Changing your preferred language will update all text on this page to the selected language. It will also change the language for this account',
    creditCheckApprovalModalTitle: 'Credit Check Application Approved',
    creditCheckApprovalModalMessage:
      'You have been approved for financing through Palmetto LightReach! You will be directed to the System Design page to continue working with your Dealer on your home improvement project.',
    goToSystemDesign: 'Going to System Design in',
  },
  [Locale.es]: {
    creditCheckApplication: 'Solicitud de Verificación de Crédito',
    softCreditInquiry: 'Consulta de crédito blanda sin impacto en el puntaje de crédito del propietario',
    applicantInformation: 'Información del Solicitante',
    applicantDescription: 'Al menos un solicitante debe figurar en el título de propiedad',
    consumerSolarApplicantDescription: 'Ingrese el nombre tal como aparece en la identificación oficial presentada',
    firstName: 'Nombre de Pila',
    middleName: 'Segundo Nombre',
    lastName: 'Apellido',
    phoneNumber: 'Número de Teléfono',
    email: 'Correo Electrónico',
    dateOfBirth: 'Fecha de Nacimiento',
    dobRequired: 'La fecha de nacimiento es obligatoria',
    socialSecurityNumber: 'Número de Seguro Social',
    ssnDescription:
      'Se requieren los últimos 4 dígitos, pero se recomienda el número de seguro social completo para obtener mejores resultados',
    fullSsnDescription: 'Se requiere el SSN completo para la verificación',
    ssnExample: 'ej. 555555555 o 5555',
    ssnErrorMessage: 'Se requieren los últimos 4 dígitos',
    ssnFullErrorMessage: 'Se requieren 9 dígitos',
    nineDigitSsnHelpText: 'Se requiere el SSN completo de 9 dígitos',
    nineDigitSsnErrorMessage: 'Se requiere un SSN completo de 9 dígitos',
    fullSsnExample: 'ej. 555555555',
    additionalApplicant: 'Solicitante Adicional',
    additionalApplicantDescription: 'Debe ser un familiar directo (p. ej., pareja de hecho, padre, hijo o hermano)',
    differentEmailRequired: 'Debe usar una dirección de correo electrónico diferente a la del solicitante principal',
    eitherApplicantQualified:
      'Cualquiera de los solicitantes puede calificar para el crédito, y al menos un solicitante debe aparecer en el informe de título de propiedad',
    addressInformation: 'Información de la Dirección Postal',
    propertyAddress: 'Información de la Dirección de la Propiedad',
    address: 'Dirección',
    address1: 'Dirección 1',
    address2: 'Dirección 2',
    city: 'Ciudad',
    state: 'Estado',
    zipCode: 'Código Postal',
    latitude: 'Latitud',
    longitude: 'Longitud',
    disclosures: 'Divulgaciones',
    disclosuresAlreadyAccepted: 'Divulgaciones ya aceptadas. No se requiere ninguna acción adicional.',
    cancel: 'Cancelar',
    submit: 'Enviar',
    firstNameRequired: 'El nombre de pila es un campo obligatorio.',
    lastNameRequired: 'El apellido es un campo obligatorio.',
    phoneNumberRequired: 'El número de teléfono es un campo obligatorio.',
    phoneNumberLength: 'El número de teléfono debe tener 10 dígitos.',
    emailRequired: 'El correo electrónico es un campo obligatorio.',
    invalidEmail: 'Dirección de correo electrónico inválida.',
    ssnRequired: 'Se requiere un mínimo de los últimos 4 dígitos del número de seguro social',
    fullSsnRequired: 'Se requiere el SSN completo',
    ssnFormat: 'El valor del SSN debe coincidir con el formato 555555555 o 5555',
    fullSsnFormat: 'El valor del SSN debe coincidir con el formato 555555555',
    addressRequired: 'La dirección es un campo obligatorio.',
    cityRequired: 'La ciudad es un campo obligatorio.',
    stateRequired: 'El estado es un campo obligatorio.',
    zipRequired: 'El código postal es un campo obligatorio.',
    creditApplicationDisclosureRequired: 'Debe aceptar la divulgación de la solicitud de crédito.',
    applicationSubmittedSuccess: 'Solicitud enviada exitosamente',
    errorSubmittingApplication: 'Error al enviar la solicitud',
    creditUnderwritingComplete: 'La Verificación de Crédito Está Completa',
    creditUnderwritingCompleteMessage:
      'La verificación de crédito para esta cuenta ya ha sido aprobada. No se permiten solicitudes adicionales',
    creditUnderwritingCompleteWithCapMessage:
      'La verificación de crédito para esta cuenta ya ha sido aprobada y ha alcanzado el límite máximo de pago mensual. No se permiten solicitudes adicionales',
    invalidSsnZeros: 'Formato de SSN no válido. El SSN no puede ser 0000.',
    invalidSsnPattern:
      'Formato de SSN no válido. El SSN no puede comenzar con 666, tener 00 como dígitos intermedios o terminar con 0000.',
    usePropAddressForMainApplicantAddress:
      'Usa la dirección de la propiedad como la dirección del solicitante principal',
    lightReachDisclosuresTitle: 'Cláusulas de LightReach',
    language: 'Idioma Preferido',
    languageDescription:
      'Seleccione su idioma preferido. Cambiar el idioma preferido establecerá el idioma preferido del cliente.',
    languageChangeAlertTitle: 'Aviso de Cambio de Idioma',
    languageChangeAlertMessage:
      'Cambiar el idioma preferido actualizará todo el texto en esta página al idioma seleccionado. También cambiará el idioma de esta cuenta',
    creditCheckApprovalModalTitle: 'Solicitud de Verificación de Crédito Aprobada',
    creditCheckApprovalModalMessage:
      '¡Ha sido aprobado para financiamiento a través de Palmetto LightReach! Será dirigido a la página de Diseño del Sistema para continuar trabajando con su Distribuidor en su proyecto de mejora del hogar.',
    goToSystemDesign: 'Ir a Diseño del Sistema en',
  },
};
